import { useUI } from "providers/UIProvider"

import { IGoogleMapProps } from "components/shared/GoogleMap/GoogleMapTypes"

import Modal from "components/UI/organisms/Modal"
import GoogleMap from "components/shared/GoogleMap"

const GoogleMapModal = (props: IGoogleMapProps) => {
  const { modals, toggleModal } = useUI()
  
  return (
    <Modal isOpen={modals.googleMapModal.isOpened} onClose={()=>toggleModal("googleMapModal", false)} styles={{ width: "700px" }}>
      <GoogleMap {...props} />
    </Modal>
  )
}

export default GoogleMapModal
